<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()" data-testid="publish-cancel">{{ Copy.Cancel }}</ion-button>
    </ion-buttons>
    <ion-title>{{ Copy.SheetTitle }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">
  <ion-list>
    <ion-item>
      <ion-input
        [label]="Copy.TitleLabel"
        labelPlacement="stacked"
        [placeholder]="Copy.TitlePlaceholder"
        [value]="title()"
        [disabled]="busy()"
        data-testid="publish-title"
        (ionInput)="title.set($any($event).detail.value ?? '')"
      ></ion-input>
    </ion-item>

    <ion-item>
      <ion-textarea
        [label]="Copy.DescriptionLabel"
        labelPlacement="stacked"
        [placeholder]="Copy.DescriptionPlaceholder"
        [autoGrow]="true"
        [value]="description()"
        [disabled]="busy()"
        data-testid="publish-description"
        (ionInput)="description.set($any($event).detail.value ?? '')"
      ></ion-textarea>
    </ion-item>

  </ion-list>

  <!-- The agreement. Rendered from what the server returned, never composed
       here: it is the record of what the publisher granted. -->
  <section class="publish-agreement">
    @if (terms(); as t) {
      <p class="publish-agreement__lead">{{ Copy.AgreementIntro }} {{ t.summary }}</p>

      <ul class="publish-agreement__terms" data-testid="publish-terms">
        @for (line of t.terms; track line) {
          <li>{{ line }}</li>
        }
      </ul>

      <a
        class="publish-agreement__link"
        [href]="agreementUrl()"
        target="_blank"
        rel="noopener"
        data-testid="publish-agreement-link"
      >
        {{ Copy.ReadAgreement }}
      </a>

      <ion-item button detail="false" lines="none" (click)="accepted.set(!accepted())" [disabled]="busy()">
        <ion-checkbox
          slot="start"
          [checked]="accepted()"
          [disabled]="busy()"
          [attr.aria-label]="Copy.AcceptLabel"
          data-testid="publish-accept"
          (click)="$event.stopPropagation()"
          (ionChange)="accepted.set($any($event).detail.checked)"
        ></ion-checkbox>
        <ion-label class="publish-agreement__accept">{{ Copy.AcceptLabel }}</ion-label>
      </ion-item>
    } @else if (!error()) {
      <div class="publish-agreement__loading">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    }
  </section>

  <!-- The backup can take a while on a big library, so say what is happening
       rather than leaving a disabled sheet with no explanation. -->
  @if (backingUp()) {
    <p class="publish-backing-up">
      <ion-spinner name="crescent"></ion-spinner>
      {{ Copy.BackingUp }}
    </p>
  }

  @if (error(); as message) {
    <ion-note color="danger" class="publish-error" data-testid="publish-error">{{ message }}</ion-note>
  }

  <!-- The submit action sits under the checkbox, not in the header: a refusal
       renders right beside the button that caused it instead of off-screen at
       the bottom of the sheet. -->
  <ion-button
    expand="block"
    class="publish-submit"
    [disabled]="!canPublish()"
    (click)="publish()"
    data-testid="publish-confirm"
  >
    {{ submittingDraft ? Copy.SubmitDraft : Copy.Publish }}
  </ion-button>

  @if (!submittingDraft) {
    <ion-button
      expand="block"
      fill="clear"
      [disabled]="busy()"
      (click)="saveDraft()"
      data-testid="publish-save-draft"
    >
      {{ Copy.SaveDraft }}
    </ion-button>
  }
</ion-content>
